import { Component, OnInit } from '@angular/core';
import { CustomLabelService } from '../../services/custom-label.service';

@Component({
  selector: 'app-label-initializer',
  template: '', // Componente invisibile
  standalone: true
})
export class LabelInitializerComponent implements OnInit {
  constructor(private customLabelService: CustomLabelService) {

  }

  ngOnInit(): void {
    // Carica le label all'avvio (solo se autenticato)
    this.customLabelService.loadAllLabels().subscribe(
      success => {
        if (success) {
         // console.log('✅ Label caricate con successo');
        } else {
          console.warn('⚠️ Errore nel caricamento delle label');
        }
      }
    );
  }
}
